import React, { useState, useEffect } from "react";
import axios from "axios";
import { testUrl } from "../../../user/home/BaseData";
import styles from "./PhoneLeadsAdmin.module.css";
import { FaTrashAlt, FaFileExcel, FaPhone, FaSync } from "react-icons/fa";
import * as XLSX from "xlsx";

const PhoneLeadsAdmin = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    const fetchLeads = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${testUrl}/api/phone-leads/`);
            setLeads(response.data);
        } catch (error) {
            console.error("Error fetching phone leads:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Haqiqatan ham bu raqamni o'chirib tashlamoqchimisiz?")) {
            try {
                await axios.delete(`${testUrl}/api/phone-leads/${id}/`);
                setLeads((prev) => prev.filter((l) => l.id !== id));
            } catch (error) {
                console.error("Error deleting lead:", error);
                alert("O'chirishda xatolik yuz berdi.");
            }
        }
    };

    const handleExportExcel = () => {
        const data = filteredLeads.map((lead, idx) => ({
            "№": idx + 1,
            "Telefon raqam": lead.phone_number,
            "Kelib tushgan sana": new Date(lead.created_at).toLocaleString("uz-UZ"),
        }));

        const ws = XLSX.utils.json_to_sheet(data);

        // Column widths
        ws["!cols"] = [{ wch: 5 }, { wch: 22 }, { wch: 24 }];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Telefon raqamlar");
        XLSX.writeFile(wb, "telefon_raqamlar.xlsx");
    };

    const filteredLeads = leads.filter((l) =>
        l.phone_number.includes(search)
    );

    const todayCount = leads.filter((l) => {
        const d = new Date(l.created_at);
        return d.toDateString() === new Date().toDateString();
    }).length;

    if (loading) {
        return (
            <div className={styles.loadingWrapper}>
                <div className={styles.loadingSpinner}></div>
                <p>Yuklanmoqda...</p>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <div className={styles.headerIcon}>
                        <FaPhone />
                    </div>
                    <div>
                        <h2 className={styles.heading}>Telefon raqamlar</h2>
                        <p className={styles.subheading}>Foydalanuvchilar qoldirgan raqamlar ro'yxati</p>
                    </div>
                </div>
                <div className={styles.headerActions}>
                    <button className={styles.refreshBtn} onClick={fetchLeads} title="Yangilash">
                        <FaSync />
                    </button>
                    <button
                        className={styles.exportBtn}
                        onClick={handleExportExcel}
                        disabled={filteredLeads.length === 0}
                    >
                        <FaFileExcel />
                        Excel yuklash
                    </button>
                </div>
            </div>

            {/* Stats */}
            <div className={styles.statsRow}>
                <div className={styles.statCard}>
                    <span className={styles.statValue}>{leads.length}</span>
                    <span className={styles.statLabel}>Jami raqamlar</span>
                </div>
                <div className={styles.statCard}>
                    <span className={styles.statValue}>{todayCount}</span>
                    <span className={styles.statLabel}>Bugun</span>
                </div>
            </div>

            {/* Search */}
            <div className={styles.searchWrapper}>
                <input
                    type="text"
                    id="phone-leads-search"
                    className={styles.searchInput}
                    placeholder="Telefon raqam bo'yicha qidirish..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {/* Table */}
            {filteredLeads.length === 0 ? (
                <div className={styles.emptyState}>
                    <FaPhone className={styles.emptyIcon} />
                    <p>{search ? "Qidiruv bo'yicha natija topilmadi." : "Hali hech qanday raqam qoldirilmagan."}</p>
                </div>
            ) : (
                <div className={styles.tableResponsive}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>Telefon raqam</th>
                                <th>Kelib tushgan sana</th>
                                <th>Amallar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLeads.map((lead, index) => (
                                <tr key={lead.id}>
                                    <td className={styles.indexCell}>{index + 1}</td>
                                    <td className={styles.phoneCell}>
                                        <span className={styles.phoneBadge}>
                                            <FaPhone className={styles.phoneRowIcon} />
                                            {lead.phone_number}
                                        </span>
                                    </td>
                                    <td className={styles.dateCell}>
                                        {new Date(lead.created_at).toLocaleString("uz-UZ", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </td>
                                    <td>
                                        <button
                                            className={styles.deleteBtn}
                                            onClick={() => handleDelete(lead.id)}
                                            title="O'chirish"
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default PhoneLeadsAdmin;
